import type { PanelName } from "../../types.ts";
import { Admin } from "../Admin.tsx";
import { Automacao } from "../Automacao.tsx";
import { CadenceCalendar } from "../CadenceCalendar.tsx";
import { ChatLayout } from "../ChatLayout.tsx";
import { Kanban } from "../Kanban.tsx";
import { Settings } from "../Settings.tsx";
import { Shortcuts } from "../Shortcuts.tsx";

type MainPanelProps = {
  panel: PanelName;
  isAdmin: boolean;
};

export function MainPanel({ panel, isAdmin }: MainPanelProps) {
  if (panel === "chats") {
    return <ChatLayout />;
  }
  if (panel === "shortcuts") {
    return <Shortcuts />;
  }
  if (panel === "settings") {
    return (
      <main className="main main-settings">
        <Settings />
      </main>
    );
  }
  if (panel === "calendar") {
    return (
      <main className="main main-calendar">
        <CadenceCalendar />
      </main>
    );
  }
  if (panel === "automacao") {
    return (
      <main className="main main-automacao">
        <Automacao />
      </main>
    );
  }
  if (panel === "admin") {
    if (!isAdmin) {
      return (
        <main className="main main-kanban">
          <Kanban />
        </main>
      );
    }
    return (
      <main className="main main-admin">
        <Admin />
      </main>
    );
  }
  return (
    <main className="main main-kanban">
      <Kanban />
    </main>
  );
}
